// extracted by mini-css-extract-plugin
module.exports = {"readMore":"body-text-module--readMore--oVW4p","chevron":"body-text-module--chevron--1qF7G"};